import { apiSlice } from "../../apiSlice";

export const bestUniApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getBestUni: build.query({
      query: () => `/public/partner/universities`,
    }),
  }),
});

export const { useGetBestUniQuery } = bestUniApi;
